import React, { useState } from 'react'
import { useIntl } from 'react-intl'
import PropTypes from 'prop-types'
import cx from 'classnames'

import { Section, Columns, Column, Rows } from '@/components/layout'
import { Text, Link, Card, IconList, Collapse } from '@/components/common'
import BuyNowCta from '@/components/BuyNowCta'
import routes from '@/routes'

import styles from './SubscriptionOffersMobile.module.scss'

const getMessageId = id => `pages.pricing.offers.${id}`

const subs = [
  { id: 'vipService', sku: 'neatvipyr', testId: 'neat-vip' },
  { hasCrown: false, id: 'automatedInsights', sku: 'neataiyr', testId: 'neat-ai' },
]

const OfferCard = ({ id, sku, testId }) => {
  const { formatMessage } = useIntl()
  const subName = formatMessage({ id: getMessageId(`${id}.title`) })
  const isVip = id === 'vipService'
  const liCount = isVip ? 4 : 5
  const [isExpanded, setIsExpanded] = useState(false)

  const commonColProps = {
    className: styles.cardColumn,
    mobileBreakpoint: 'small',
  }

  return (
    <Card className={cx(styles.card, isVip && styles.vip)} withShadow>
      <Columns gap={0}>
        <Column {...commonColProps} gap={1} size={45}>
          <Text.H3 className={styles.subName}>{subName}</Text.H3>
          <Rows className={styles.row}>
            <Text.H5 brandPrimary className={styles.subtitle} messageId={getMessageId(`${id}.subtitle`)} noMargin />
            <BuyNowCta
              data-buyinfo={`{"sku":"${sku}","source":"Checkout"}`}
              data-testid={`pricing-page-buy-${testId}`}
              size="medium"
              sku={sku}
            />
          </Rows>
          <Link
            bold
            className={styles.learnCta}
            messageProps={{ id: getMessageId('learnMoreCta'), values: { type: subName } }}
            size="xsmall"
            to={routes[id]}
          />
          <Text bold element="div" messageId={getMessageId('restriction')} secondary size="xsmall" />
        </Column>
        <Column bgBrand className={`${styles.details} ${isExpanded && styles.isExpanded}`} onClick={() => setIsExpanded(wasExpanded => !wasExpanded)}>
          <Text bold brandSecondary className={styles.text} element="div">Details</Text>
          <div className={styles.arrow} />
        </Column>
        <Collapse isOpen={isExpanded}>
          <Column bgBrand {...commonColProps} gap={12} size={55}>
            <Text.P brandSecondary messageId={getMessageId(`${id}.description`)} />
            <IconList
              items={Array.from(Array(liCount).keys())
                .map((ix) => ({ text: formatMessage({ id: getMessageId(`${id}.li${ix + 1}`) }), id: `li${ix}`, className: styles.white, src: '/pricing/list-icons/circle-bullet-white.svg' }))}
              small
            />
          </Column>
        </Collapse>
      </Columns>
    </Card>
  )
}

OfferCard.propTypes = {
  id: PropTypes.string.isRequired,
  sku: PropTypes.string.isRequired,
  testId: PropTypes.string.isRequired,
  hasCrown: PropTypes.bool,
}

export default function SubscriptionOffersMobile() {
  return (
    <Section paddingHorizontal={0} paddingVertical={0}>
      <Rows>
        {subs.map(sub => <OfferCard {...sub} key={sub.id} />)}
      </Rows>
    </Section>
  )
}
